import React from 'react';
import './FormsDownloadLink.css';
import PDF from '../media/img/pdf.png';

function FormsDownloadLink({ text, downloadUrl }) {
  return (
    <a
      className='FormsDonwloadLink'
      href={downloadUrl}
      download
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: 'none', color: 'inherit' }}
    >
      <div>
        <h2>{text}</h2>
        <img src={PDF} style={{ height: '35px', marginTop: '6px' }} alt="PDF icon" />
      </div>
    </a>
  );
}

export default FormsDownloadLink;